// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__yZ3W1","sliderTrack":"Slider_sliderTrack__AAYvi","sliderThumb":"Slider_sliderThumb__IxdtM","legend":"Slider_legend__+87aZ"};